export const TRENDING_LIMIT = 5;

export const PLAYER_IMAGE_ASPECTS_WIDTHS = [460, 620, 940, 1180];
